<template>
    <nav class="panel">
        <p class="panel-heading">
            Consignees
        </p>
        <a class="panel-block" v-for="item in list">
            <span class="panel-icon">
              <i class="far fa-address-card"></i>
            </span>
            {{ item.name }} {{ item.street }}, {{ item.city }}, {{ item.country }}, {{ item.phone }}, {{ item.email }}
        </a>
        <div class="panel-block">
            <button class="button is-link is-outlined is-fullwidth" @click="createForm = !createForm">
                + create new
            </button>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field">
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-model="consignee.name" class="input" placeholder="Name">
                    <span class="icon is-small is-left">
                        <i class="fas fa-user"></i>
                    </span>
                    <p v-if="errors.name" class="help is-danger">{{ errors.name[0] }}</p>
                </div>
            </div>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field is-fullwidth">
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-model="consignee.street" class="input" placeholder="Street">
                    <span class="icon is-small is-left">
                        <i class="fas fa-road"></i>
                    </span>
                    <p v-if="errors.street" class="help is-danger">{{ errors.street[0] }}</p>
                </div>
            </div>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field is-fullwidth">
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-model="consignee.city" class="input" placeholder="City">
                    <span class="icon is-small is-left">
                        <i class="fas fa-city"></i>
                    </span>
                    <p v-if="errors.city" class="help is-danger">{{ errors.city[0] }}</p>
                </div>
            </div>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field is-fullwidth">
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <div class="select is-fullwidth">
                        <select v-model="consignee.country">
                            <option value="" hidden disabled>Country</option>
                            <option v-for="country in countries">{{ country.name }}</option>
                        </select>
                    </div>
                    <span class="icon is-small is-left">
                        <i class="fas fa-globe"></i>
                    </span>
                    <p v-if="errors.country" class="help is-danger">{{ errors.country[0] }}</p>
                </div>
            </div>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field">
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-model="consignee.phone" class="input" placeholder="Phone">
                    <span class="icon is-left">
                        <i class="fas fa-phone"></i>
                    </span>
                    <p v-if="errors.phone" class="help is-danger">{{ errors.phone[0] }}</p>
                </div>
            </div>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field">
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-model="consignee.email" class="input" placeholder="Email">
                    <span class="icon is-left">
                        <i class="fas fa-at"></i>
                    </span>
                    <p v-if="errors.email" class="help is-danger">{{ errors.email[0] }}</p>
                </div>
            </div>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field">
                <button class="button is-primary is-fullwidth" @click.prevent="createNewItem" :class="{ 'is-loading': isLoading }">
                    Save
                </button>
            </div>
        </div>
    </nav>
</template>

<script>
    import apiConsignees from '../../api/apiConsignees'
    import axios from 'axios'
    export default {
        data () {
            return {
                createForm: false,
                isLoading: false,
                countries:[],
                list:[],
                consignee: {
                    user_id: this.$route.params.id,
                    name: '',
                    street: '',
                    city: '',
                    country: '',
                    phone: ''
                },
                errors: {
                    name: '',
                    street: '',
                    city: '',
                    country: '',
                    phone: ''
                }
            }
        },
        methods: {
            createNewItem() {
                this.isLoading = true
                this.clearAllErrors()
                apiConsignees
                    .createConsigneeRequest(this.consignee)
                    .then(response => {
                        this.isLoading = false
                        this.list.push(response.data)
                        this.clearForm()
                    })
                    .catch((err) => {
                        this.isLoading = false
                        if ( err.response && err.response.status === 422 ) {
                            this.errors = err.response.data
                        }
                    })
            },
            clearAllErrors() {
                this.errors = {
                    name: '',
                    street: '',
                    city: '',
                    country: '',
                    phone: ''
                }
            },
            clearForm() {
                this.createForm = false
                this.consignee = {
                        user_id: this.$route.params.id,
                        name: '',
                        street: '',
                        city: '',
                        country: '',
                        phone: ''
                }
            }
        },
        created () {
            this.consignee.user_id = this.$route.params.id
            apiConsignees
                .consigneesListRequest(this.consignee.user_id)
                .then(response => {
                    this.list = response.data
                })
                .catch(err => console.log(err))
        },
        mounted () {
            axios.get('https://restcountries.com/v3.1/all?fields=name')
                .then((response) => {
                    this.countries = response.data
                })
        }
    }
</script>

<style scoped>
    .field {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Profile/Consignees.vue